import { forwardRef } from 'react'

import { StyledButton } from './Button.styles'
import { ButtonContent } from './ButtonContent'
import type { ButtonProps } from './types'

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    return (
      <StyledButton {...props} aria-busy={!!props.isLoading} ref={ref}>
        <ButtonContent {...props} />
      </StyledButton>
    )
  },
)
